import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import '../pages.scss';
import Snackbar from "../../components/snackbar.mjs";
import { GenerateCode } from '../../components/genCode.mjs';
import TopNavBar from '../../components/topNavBar.mjs';


const ManageClassesPage = () => {
    const [classCode, setClassCode] = useState(""); // ClassID most recently created
    const [joinCode, setJoinCode] = useState(""); // ClassID entered to join
    const [classNameInput, setClassNameInput] = useState(""); // ClassName entered to create
    const [classNameCreated, setClassNameCreated] = useState(""); // Most recently created ClassName
    const [classTypeChoice, setClassTypeChoice] = useState(""); // Type for class to be created
    const [teacherPIN, setTeacherPIN] = useState(""); // PIN Generated
    const [classOfPIN, setClassOfPIN] = useState("") // Class associated with PIN generated

    const [hasSetup, setHasSetup] = useState(false); // Has the page set up for the first time
    const [classesList, setClassesList] = useState([]); // Array of classes managed by teacher retrieved from cloud and hardware class associations

    const navigate = useNavigate();

    const keygenID = sessionStorage.getItem('keygenID');
    const userToken = sessionStorage.getItem('userToken');
    var userType = sessionStorage.getItem("userType");
    var email = sessionStorage.getItem("email");
    var firstName = sessionStorage.getItem("firstName");
    var lastName = sessionStorage.getItem("lastName");
    var name = firstName + " " + lastName;

    const cloudConciergeURL = "https://syglasscloudconcierge.net";

    const getOptions = {
		method: 'GET',
		cache: 'no-store'
	}

    const handleRefreshClasses = async () => {
        if (userType === "Teacher" || userType === "Scientist") {
            var classCodes = [];
            // Fetch cloud classes
            await fetch("/getClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
            .then(response => response.json())
            .then(async data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

                if (data !== undefined && data.Item !== undefined && data.Item.Classes !== undefined) {
                    for (let i = 0; i < data.Item.Classes.L.length; i++) {
                        var cls = [];
                        var code = data.Item.Classes.L[i].S;
                        cls.push(code);

                        await fetch("/getClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code, getOptions)
                        .then(response => response.json())
                        .then(data => {
                            if (data === "Not Authorized") {
                                sessionStorage.clear();
                                navigate("/");
                                return;
                            }

                            if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
                                cls.push(data.Item.ClassName.S);
                                cls.push("Cloud");
                                classCodes.push(cls);
                            } else {
                                console.log(data.Item.ClassName.S + " with code " + code + " has been marked for deletion.");
                            }
                        })
                        .catch(error => console.log(error));
                    }
                }
            })
            .catch(error => console.log(error));

            // Fetch hardware classes
            await fetch("/getHardClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
            .then(response => response.json())
            .then(async data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

                if (data !== undefined && data.Item !== undefined && data.Item.Classes !== undefined) {
                    for (let i = 0; i < data.Item.Classes.L.length; i++) {
                        var cls = [];
                        var classid = data.Item.Classes.L[i].S;
                        cls.push(classid);

                        await fetch("/getHardClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classid, getOptions)
                        .then(response => response.json())
                        .then(data => {
                            if (data === "Not Authorized") {
                                sessionStorage.clear();
                                navigate("/");
                                return;
                            }

                            if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
                                cls.push(data.Item.ClassName.S);
                                cls.push("Hardware");
                                classCodes.push(cls);
                            } else {
                                console.log(data.Item.ClassName.S + " with code " + classid + " has been marked for deletion.");
                            }
                        })
                        .catch(error => console.log(error));
                    }
                }
            })
            .catch(error => console.log(error));

            setClassesList(classCodes);
        } 
    }

    if(!hasSetup) {
        setHasSetup(true);
        handleRefreshClasses();
    }

    const handleCreateClass = async () => {           
        if (classTypeChoice === "") {
            Snackbar("classType", 7000);
            return;
        }
        if (classNameInput.length === 0) {
            Snackbar("classNam", 7000);
            return;
        }

        const generatedCode = GenerateCode(6, 36);

        if (classTypeChoice === "Cloud") {
            await fetch("/createCloudClass", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userID: keygenID, token: userToken, name: name, classID: "C" + generatedCode, email: email, className: classNameInput }),
            })
            .then(response => response.json())
            .then(async data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

                if (data.success) {
                    var textInput = document.getElementById("classNameInput");
                    textInput.value = '';
                    setClassCode("C" + generatedCode);
                    setClassNameCreated(classNameInput);
                    Snackbar("createSuccess", 7000);
                    handleRefreshClasses();
                } else {
                    if (data.message === "Max classes") {
                        Snackbar("maxClass", 10000);
                        return;
                    } else if (data.message === "Went wrong") {
                        Snackbar("wentWrong", 10000);
                        return;
                    } else if (data.message === "Collision") {
                        handleCreateClass();
                    } else {
                        Snackbar("wentWrong", 10000);
                        return;
                    }
                }
            })
            .catch(error => {
                console.log(error);
                Snackbar("wentWrong", 10000);
            });
        } else if (classTypeChoice === "Hardware") {
            await fetch("/createHardwareClass", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userID: keygenID, token: userToken, classID: "H" + generatedCode, className: classNameInput }),
            })
            .then(response => response.json())
            .then(async data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

                if (data.success) {
                    var textInput = document.getElementById("classNameInput");
                    textInput.value = '';
                    setClassCode("H" + generatedCode);
                    setClassNameCreated(classNameInput);
                    Snackbar("createSuccess", 7000);
                    handleRefreshClasses();
                } else {
                    if (data.message === "Max classes") {
                        Snackbar("maxClass", 10000);
                        return;
                    } else if (data.message === "Went wrong") {
                        Snackbar("wentWrong", 10000);
                        return;
                    } else if (data.message === "Collision") {
                        handleCreateClass();
                    } 
                }
            })
            .catch(error => {
                console.log(error);
                Snackbar("wentWrong", 10000);
            });
        } else {
            Snackbar("wentWrong", 10000);
            return;
        }    
    }

    const handleJoinClass = async () => {
        var typeCode = joinCode[0];

        if (typeCode === "C") {
            if (email === undefined || name === undefined) {
                Snackbar("emptyInfo", 10000);
                return;
            }

            await fetch("/enrollUserInCloudClass", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userID: keygenID, token: userToken, name: name, classID: joinCode, email: email }),
            })
            .then(response => response.json())
            .then(async data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

                if (data.success) {
                    var textInput = document.getElementById("classCode");
                    textInput.value = '';
                    Snackbar("successJoin", 7000);
                    handleRefreshClasses();
                } else {
                    if (data.message === "Non-existent") {
                        Snackbar("classTypeError", 10000);
                        return;
                    } else if (data.message === "Deleted") {
                        Snackbar("classdeletedError", 10000);
                        return;
                    } else if (data.message === "Duplicate") {
                        Snackbar("dupEnroll", 10000);
                        return;
                    }
                }
            })
            .catch(error => {
                console.log(error);
                Snackbar("wentWrong", 10000);
            });
        } else if (typeCode === "H") {
            Snackbar("entersyGlass", 10000);
            return;
        } else {
            Snackbar("wrongClassCodeType", 10000);
            return;
        }
    }

    const handleGenPIN = async (e) => {
		e.preventDefault();
        var code = e.target.parentElement.children[3].lastChild.data;
        var cname = e.target.parentElement.children[1].innerText.toString();
        cname = cname.substring(0, cname.length - 1);

		var teacherPIN = GenerateCode(4, 9);
		var timeMil = Date.now();

		await fetch("/cachePIN/?userID=" + keygenID + "&token=" + userToken + "&PIN=" + teacherPIN + "&time=" + timeMil)
			.then(response => response.json())
			.then(data => {
                if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				data = data.cacheRes;
				if (data !== teacherPIN.toString()) {
					if (data === undefined) {
						handleGenPIN(e);
					} else {
						fetch(cloudConciergeURL + "/serverApp/acceptPin/?pin=" + teacherPIN + "&name=" + firstName + "%20" + lastName + "&token=" + userToken + "&id=" + keygenID + "&replace=" + data + "&class=" + code)
						.then(response => response.json())
						.then(data => {
                            if (data === "Not Authorized") {
                                sessionStorage.clear();
                                navigate("/");
                                return;
                            }

                            if (data === "Received") {
                                setTeacherPIN(teacherPIN);
                                setClassOfPIN(cname);
                            }
						})
                        .catch(error => {
							console.log(error);
							Snackbar("wentWrongPINSend", 10000);
						});
					}
				} else {
					fetch(cloudConciergeURL + "/serverApp/acceptPin/?pin=" + teacherPIN + "&name=" + firstName + "%20" + lastName + "&token=" + userToken + "&id=" + keygenID + "&class=" + code)
					.then(response => response.json())
					.then(data => {
                        if (data === "Not Authorized") {
                            sessionStorage.clear();
                            navigate("/");
                            return;
                        }

                        if (data === "Received") {
                            setTeacherPIN(teacherPIN);
                            setClassOfPIN(cname);
                        }
					})
                    .catch(error => {
                        console.log(error);
                        Snackbar("wentWrongPINSend", 10000);
                    });
				}
			})
			.catch(error => {
				console.log(error);
				Snackbar("wentWrongPIN", 10000);
			});
	}

    const handleDiscard = () => {
        var classTypes = document.getElementsByName("classChoice");
        for (var i = 0; i < classTypes.length; i++) {
            classTypes[i].checked = false;
        }

        var input = document.getElementById("classNameInput");
        input.value = "";

        setClassTypeChoice("");
    }

    const handleDeleteClass = (e) => {
        e.preventDefault();

        var code = e.target.parentElement.parentElement.parentElement.children[3].lastChild.data;
        var type = e.target.parentElement.parentElement.parentElement.children[2].lastChild.data;

        if (!window.confirm("You have selected to delete this class, all content will be deleted.")) {
            return;
        }

        var url;
        if (type === "Cloud") {
            url = "markCloudDelete";
        } else {
            url = "markHardDelete";
        }
        
        fetch("/" + url + "/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code)
        .then(data => {
            if (data === "Not Authorized") {
                sessionStorage.clear();
                navigate("/");
                return;
            }

            if (data.status === 200) {
                Snackbar("deleteSuccess", 10000);
                handleRefreshClasses();
            } else {
                Snackbar("wentWrong", 10000);
            }
        })
        .catch(error => console.log(error));
    }

    if (classesList[0] !== undefined && classesList[0][1] !== undefined) {
        var classList = classesList.map((row) => 
            <div className="classListItem" key={row[0]} style={{width:'297px', border:"1px solid #B9B9B9", borderRadius:'8px', margin:'10px', padding:'10px'}}>
                <div id="deleteIcon" onClick={handleDeleteClass} className="" style={{marginLeft:'275px'}}><i id="deleteIcon" style={{display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'top', width:'20px', height:'20px', marginRight:'0px'}}><span id="deleteIcon" class="material-symbols-outlined">delete</span></i></div>
                <p style={{width:'297px', marginLeft:'19px', textAlign:'left'}}><b>{row[1]}</b>:</p>
                <p style={{width:'297px', marginLeft:'19px', textAlign:'left'}}>Class type: {row[2] === "Hardware" ? "PC" : row[2]}</p>
                <p style={{width:'297px', marginLeft:'19px', textAlign:'left'}}>Class code: {row[0]}</p>
                {row[2] === "Cloud" ? <button style={{display:"inline", width:"75%", marginBottom:'14px'}} className="btn" onClick={(e) => handleGenPIN(e)}>Generate PIN to enter VR</button> : <div style={{display:'none'}}></div>}
                <br></br>
            </div>
        );
    }
    
    return (
        <>
        <div>
            <TopNavBar></TopNavBar>
        </div>
        <div className="page" id="homePage">
            <div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>

            <br></br>
            <div className="snackbarYellow" id="maxClass">You have reached the maximum amount of classes allowed</div>
            <div className="snackbarYellow" id="classType">Select a class type to create a class</div>
            <div className="snackbarYellow" id="classNam">Enter a name for the class</div>
            <div className="snackbarRed" id="wentWrong">Something went wrong. Please try again or contact us for help.</div>
            <div className="snackbarNormal" id="createSuccess">The class "{classNameCreated}": {classCode} has been created</div>
            <div className="snackbarRed" id="classTypeError">The class code entered does not exist. Ensure you have entered it correctly and have the correct type</div>
            <div className="snackbarYellow" id="dupEnroll">You are already enrolled in this class</div>
            <div className="snackbarRed" id="emptyInfo">Your account information is empty. Could not enroll</div>
            <div className="snackbarNormal" id="successJoin">Class enrollment successful</div>
            <div className="snackbarRed" id="wrongClassCodeType">The class code entered is unrecognizable. Ensure you have entered it correctly and have the correct type</div>
            <div className="snackbarRed" id="entersyGlass">The class code entered is the wrong type. Class codes beginning with "H" should be entered in syGlass</div>
            <div className="snackbarNormal" id="deleteSuccess">Class has been deleted</div>
            <div className="snackbarRed" id="wentWrongPIN">Something went wrong when attempting to assign PIN. Try again</div>
            <div className="snackbarRed" id="wentWrongPINSend">Something went wrong when sending PIN for login. Try again. If the problem persists, contact us for support</div>
            <div className="snackbarRed" id="classdeletedError">The class code entered belongs to a class that has been deleted</div>

            <div style={(userType === "Teacher" || userType === "Scientist") ? {display:'block', width:'1120px', fontSize:'14px'} : {display:'none'}} className="createClassDiv">
                <p style={classesList.length === 0 ? {fontSize:'14px', textAlign:'left', width:'1120px', wordBreak:'break-word', lineHeight:'1.75'} : {display:'none'}}>Get started by creating your first class.</p>
                <br></br>

                <div style={{display:'flex', flexDirection:'row'}}>
                    <div style={{width:'297px', height:'fit-content', border:"1px solid #B9B9B9", borderRadius:'8px', padding:'10px'}}>
                        <p style={{textAlign:'left', marginLeft:'15px', marginBottom:'5px'}}>Class name: </p>
                        <input style={{float:'left', marginBottom:'17px', marginLeft:'15px'}} id="classNameInput" type="text" placeholder='Enter class name' onChange={(e) => setClassNameInput(e.target.value)}></input>
                        <br></br>
                        <p style={{fontSize:'14px', textAlign:'left', width:'1120px', wordBreak:'break-word', marginLeft:'15px', marginBottom:'5px', marginTop:'50px'}}>Class type: </p>
                        <div className="secText" style={{textAlign:'left', marginLeft:'15px', lineHeight:'2', marginBottom:'10px'}}>
                            <input name="classChoice" type="radio" value="Cloud" onClick={(e) => setClassTypeChoice("Cloud")}></input>
                            <label style={{display:'inline', marginRight:'10px'}}>Cloud</label>
                            <br></br>
                            <input name="classChoice" type="radio" value="Hardware" onClick={(e) => setClassTypeChoice("Hardware")}></input>
                            <label style={{display:'inline'}}>PC</label>
                        </div>
                        <div style={{width:'297px', marginBottom:'20px'}}>
                            <p style={classTypeChoice === "Hardware" ? {marginBottom:'30px', textAlign:'left', marginLeft:'15px'} : {display:'none'}}>PC class: Students connect to syGlass using a wired connection to a laptop or computer station.</p>
                            <p style={classTypeChoice === "Cloud" ? {marginBottom:'30px', textAlign:'left', marginLeft:'15px'} : {display:'none'}}>Cloud class: Students connect to syGlass wirelessly using syGlass Cloud.</p>
                        </div>
                        <div style={{marginBottom:'20px'}}>
                            <div style={{marginRight:'17px', width:'100px', height:'33px', display:'inline-block'}}>
                                <button className="btn" onClick={handleCreateClass}>Create</button>
                            </div>
                            <div style={{width:'105px', height:'33px', display:'inline-block'}}>
                                <button className="btnInverse" onClick={handleDiscard}>Discard</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <br></br>
                <div>
                    <div style={teacherPIN.length !== 0 ? {width:'fit-content', display:'block', marginBottom:'46px', marginTop:'26px', left:'0'} : {display:'none'}}>
                        <p style={{textAlign:'left'}}>PIN generated for the following class and valid for 1 hour</p>
                        <p style={{textAlign:'left',fontSize:'14px'}}><b>Class name:</b> {classOfPIN}</p>
                        <p style={{textAlign:'left',fontSize:'14px'}}><b>PIN:</b>      {teacherPIN.substring(0,2)} {teacherPIN.substring(2,4)}</p>
                    </div>

                    <p style={{marginBottom:'21px', textAlign:'left'}}>Created classes</p>

                    <div style={(userType === "Teacher" || userType === "Scientist") ? {display:'flex', justifyContent:'left', flexWrap:'wrap'} : {display:'none'}}>
                        {classList}
                    </div>
                </div>
            </div>

            <div style={(userType === "Scientist" || userType === "Student") ? {display:'block', width:'1120px', fontSize:'14px'} : {display:'none'}} className="joinClassDiv">
                <div style={{display:'flex'}}>
                    <p style={classesList.length === 0 ? {fontSize:'14px', textAlign:'left', width:'520px', wordBreak:'break-word', flexShrink:'0'} : {display:'none'}}>
                        Enroll in class by entering the code provided by your teacher or group leader.
                    </p> 
                </div>
                <br></br>

                <div style={{width:'500px', marginBottom:'100px'}}>
                    <p style={{alignText:'left', width:'fit-content'}}>Class code</p>
                    <div style={{display:'flex', flexDirection:'row'}}>
                        <div style={{width:'130px', height:'40px', textAlign:'left'}}>
                            <input type="text" id="classCode" name="classCode" style={{textAlign:'left', marginRight:'5px'}} onChange={(e) => setJoinCode(e.target.value)} placeholder="Enter class code" ></input>
                        </div>
                        <div style={{width:'181px', height:'33px', marginLeft:'15px', marginTop:'7px'}}>
                            <button className="btn" onClick={handleJoinClass}>Enroll in class</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default ManageClassesPage;